import Cookies from "js-cookie";

/***************常量 ***************/
export const STORAGE = {
	TOKEN_KEY: "token",
	USER_ID_KEY: "userId",
	REGION_KEY: "region",
	DEVICE_ID_KEY: "deviceId",
	ACTIVITY_ID_KEY: "activityId", // 运营活动标识
};

// 存储过期时间 1年
const EXPIRES_DAYS = 365;

// 获取主域名
const getMainDomain = () => {
	const hostname = window.location.hostname;
	const parts = hostname.split(".");

	// 如果是 localhost 或 IP 地址，直接返回
	if (hostname === "localhost" || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
		return hostname;
	}

	// 如果是二级域名或更深，返回主域名
	if (parts.length > 2) {
		return parts.slice(-2).join(".");
	}

	return hostname;
};

const setAuthInfo = (userId: string, token: string, region: string) => {
	const domain = getMainDomain();

	Cookies.set(STORAGE.USER_ID_KEY, userId, {
		expires: EXPIRES_DAYS,
		domain: domain,
		sameSite: "strict",
	});
	Cookies.set(STORAGE.TOKEN_KEY, token, {
		expires: EXPIRES_DAYS,
		domain: domain,
		sameSite: "strict",
	});
	Cookies.set(STORAGE.REGION_KEY, region, {
		expires: EXPIRES_DAYS,
		domain: domain,
		sameSite: "strict",
	});
};

const getAuthInfo = () => {
	return {
		userId: Cookies.get(STORAGE.USER_ID_KEY),
		token: Cookies.get(STORAGE.TOKEN_KEY),
		region: Cookies.get(STORAGE.REGION_KEY),
	};
};

const clearAuthInfo = () => {
	const domain = getMainDomain();

	Cookies.remove(STORAGE.USER_ID_KEY, { domain });
	Cookies.remove(STORAGE.TOKEN_KEY, { domain });
	Cookies.remove(STORAGE.REGION_KEY, { domain });
};

/***************其他 --- 设备 ***************/
const setDeviceId = (deviceId: string) => {
	const domain = getMainDomain();

	Cookies.set(STORAGE.DEVICE_ID_KEY, deviceId, {
		expires: EXPIRES_DAYS,
		domain: domain,
		sameSite: "strict",
	});
};

const getDeviceId = () => {
	return Cookies.get(STORAGE.DEVICE_ID_KEY);
};

const clearDeviceId = () => {
	const domain = getMainDomain();
	Cookies.remove(STORAGE.DEVICE_ID_KEY, { domain });
};

/***************其他 --- 运营活动 ***************/
const setActivityId = (activityId: string) => {
	const domain = getMainDomain();

	Cookies.set(STORAGE.ACTIVITY_ID_KEY, activityId, {
		expires: EXPIRES_DAYS,
		domain: domain,
		sameSite: "strict",
	});
};

const getActivityId = () => {
	return Cookies.get(STORAGE.ACTIVITY_ID_KEY);
};

const clearActivityId = () => {
	const domain = getMainDomain();
	Cookies.remove(STORAGE.ACTIVITY_ID_KEY, { domain });
};

export {
	setAuthInfo,
	getAuthInfo,
	clearAuthInfo,
	setDeviceId,
	getDeviceId,
	clearDeviceId,
	setActivityId,
	getActivityId,
	clearActivityId,
};
